import React from "react";
import AppButton from "../../../../components/AppButton";
import { IconAdd, IconArrowRight, IconDelete, IconFilter } from "../../../../icons";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const variantItems = [
  { variant: "primary", label: "Primary" },
  { variant: "info", label: "Info" },
  { variant: "outlined", label: "Outlined" },
  { variant: "neutral", label: "Neutral" },
  { variant: "muted", label: "Muted" },
  { variant: "error", label: "Error" },
];

const sizeItems = [
  { size: "xs", label: "XS" },
  { size: "sm", label: "SM" },
  { size: "md", label: "MD" },
  { size: "lg", label: "LG" },
];

const niceToKnowItems = [
  "MD ist Standard für Pages und Dialoge.",
  "SM passt für Cards und kompaktere Bereiche.",
  "XS für dichte Inline- und Tabellenaktionen.",
  "Primary nur für die wichtigste Aktion pro Bereich.",
  "Info kennzeichnet eine vorhandene Information oder einen informativen Zustand.",
  "Error nur für destruktive Aktionen.",
];

const niceToKnowHighlights = [
  "→ Icon-Only-Buttons immer mit Tooltip!",
  "→ Icon-Grösse kommt direkt von Button-Grösse!",
  "→ I.d.R. immer Leading-Icons!",
];

function PreviewRow({ label, children }) {
  return (
    <div className="ds-docs-preview-row">
      <div className="ds-docs-preview-row__label">{label}</div>
      <div className="ds-docs-preview-row__content">{children}</div>
    </div>
  );
}

export default function ButtonsDocs() {
  return (
    <DocsSectionCard title="Buttons">
      <div className="ds-docs-spotlight-grid">
        <DocsPreviewPanel>
          <div className="ds-docs-preview-surface ds-docs-button-preview">
            <PreviewRow label="Varianten">
              {variantItems.map((item) => (
                <AppButton key={item.variant} variant={item.variant} size="sm">
                  {item.label}
                </AppButton>
              ))}
            </PreviewRow>

            <PreviewRow label="Grössen">
              {sizeItems.map((item) => (
                <AppButton key={item.size} variant="neutral" size={item.size}>
                  {item.label}
                </AppButton>
              ))}
            </PreviewRow>

            <PreviewRow label="Icons">
              <AppButton variant="primary" size="sm">
                <IconAdd />
                Neu
              </AppButton>
              <AppButton variant="outlined" size="sm">
                Weiter
                <IconArrowRight />
              </AppButton>
              <AppButton variant="muted" size="sm" iconOnly aria-label="Filter öffnen">
                <IconFilter />
              </AppButton>
            </PreviewRow>

            <PreviewRow label="Disabled">
              <AppButton variant="primary" size="sm" disabled>
                Speichern
              </AppButton>
              <AppButton variant="neutral" size="sm" disabled>
                Abbrechen
              </AppButton>
              <AppButton variant="error" size="sm" iconOnly disabled aria-label="Löschen">
                <IconDelete />
              </AppButton>
            </PreviewRow>
          </div>
        </DocsPreviewPanel>

        <DocsNiceToKnow items={niceToKnowItems} highlightItems={niceToKnowHighlights} />
      </div>
    </DocsSectionCard>
  );
}
